import { CoreMenu } from 'src/@core/types';
import { environment } from 'src/environments/environment.development';

export const leadKonnektMenu: CoreMenu[] = [
  {
    id: 'Organizations',
    title: 'Organizations',
    type: 'item',
    icon: 'workspace.svg',
    url: '/lead-konnekt/organizations',
    role: {
      roles: ['employee'],
      right: 'I1007',
    },
  },
  {
    id: 'customers',
    title: 'Customers',
    type: 'item',
    icon: 'customers.svg',
    url: 'lead-konnekt/customers',
    role: { roles: ['employee'], right: 'I1007' },
  },
  {
    id: 'tickets',
    title: 'Tickets',
    type: 'item',
    icon: 'tickets.svg',
    url: 'lead-konnekt/tickets',
    role: {
      roles: ['employee', 'customer'],
      right: 'I1016',
    },
  },
  {
    id: 'Campaigns',
    title: 'Campaigns',
    type: 'item',
    icon: 'campaign.svg',
    url: `${environment.leadKonnekt_url}/app/all-forms`,
    externalUrl: true,
    role: {
      roles: ['employee'],
      right: 'I1000',
    },
  },
  {
    id: 'Leads',
    title: 'Leads',
    type: 'item',
    icon: 'lead.svg',
    url: `${environment.leadKonnekt_url}/app/all-leads`,
    externalUrl: true,
    role: {
      roles: ['employee'],
      right: 'I1011',
    },
  },
  // {
  //   id: 'UAT-Activity',
  //   title: 'UAT Activity',
  //   type: 'item',
  //   icon: 'uat.svg',
  //   url: '/lead-konnekt/uat/activity',
  //   role: {
  //     roles: ['employee', 'customer'],
  //     right: 'I1022',
  //   },
  // },
];
